import { createFileRoute } from "@tanstack/react-router";
import { TenantDetail } from "@client/components/settings/tenant-management/tenant-detail";

export const Route = createFileRoute("/_app/settings/tenants/$tenantId")({
  component: TenantDetail,
});
